import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {UserService} from '../services/user/user.service';
import {MyCognitoUser, isStudent} from '../cognito-user-interfaces';
import {UserDto} from '@api/utisha-backend';

@Directive({ selector: '[isStudent]' })

export class IsStudentDirective {
  user: UserDto;
  initialized = false;

  constructor(
    private userService: UserService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef) {
    this.userService.getUserObservable().subscribe({next: (user: UserDto | undefined) => this.updateUser(user)});
  }

  updateUser(user?: UserDto): void {
    if (this.initialized || !user) {
      return;
    }
    this.initialized = true;
    this.user = user;
    if (isStudent(this.user)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
